// Feet on a 50 x 47 half court, basket at (25, 5.25), high school 3-point line at 19 ft 9 in.
// Same rules as the backend (shot_chart.classify).
const HOOP = [25, 5.25];
const THREE = 19.75;

export const classify = (x, y) => {
  const dx = x - HOOP[0];
  const dist = Math.hypot(dx, y - HOOP[1]);
  const three = y <= HOOP[1] ? Math.abs(dx) >= THREE : dist >= THREE;
  if (!three) return dist <= 4 ? [2, "rim"] : Math.abs(dx) <= 6 && y <= 19 ? [2, "paint"] : [2, "midrange"];
  if (y <= 14 && Math.abs(dx) >= 17) return [3, "corner3"];
  return [3, Math.abs(dx) >= 9 ? "wing3" : "top3"];
};
